export default "__VITE_ASSET__DI3DN29l__"